import { Component, Inject, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { WindowToken } from "@app/util/window.token";

const leavingMessage = 'Links to third-party websites may have a privacy policy different from First Citizens Bank and may provide less security than this website. ' +
    'First Citizens Bank and its affiliates are not responsible for the products, services and content on any third-party website.';

@Component({
    selector: 'app-custom-content',
    template: `
        <div *ngIf="!allowLink" [innerHTML]="sanitizedContent"></div>
        <div *ngIf="allowLink" (click)="clickLink()" [innerHTML]="sanitizedContent"></div>
    `
})
export class CustomContentComponent implements OnInit{

    @Input() contentMessage: string;

    sanitizedContent: SafeHtml;

    allowLink: boolean = false;

    constructor(@Inject(DomSanitizer) private sanitizer: DomSanitizer, @Inject(WindowToken) private window,) {}

    ngOnInit(): void {

        this.checkForLinks()
        this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.contentMessage);

    }

    private checkForLinks() {

        const regex = /href=['"](http[\S]+)['"]/g;
        let indexOfRegex = this.contentMessage.search(regex);

        if (indexOfRegex >= 0) {
            this.allowLink = true;
        }
    }

    clickLink() {
        alert(leavingMessage);
    }
}
